module.exports = __webpack_public_path__ + "img/ro.2cc0396f.png";